// extracted by mini-css-extract-plugin
export default {"host":"PageHeaderRowEnganced_host__zrZ4Q"};